import { render, staticRenderFns } from "./Linker.vue?vue&type=template&id=5b4a8e28&scoped=true&"
import script from "./Linker.vue?vue&type=script&lang=js&"
export * from "./Linker.vue?vue&type=script&lang=js&"
import style0 from "./Linker.vue?vue&type=style&index=0&id=5b4a8e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a8e28",
  null
  
)

export default component.exports